// patientApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const patientApi = createApi({
    reducerPath: 'patientApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedPatientApi = patientApi.injectEndpoints({
    endpoints: (builder) => ({
        patientList: builder.mutation({
            query: (patientListConfig) => ({
                url: '/patient/NewsearchPatients',
                method: 'POST',
                body: patientListConfig,
            }),
        }),
        patientDraftList: builder.mutation({
            query: (patientListConfig) => ({
                url: '/patient/NewsearchPatientsDraft',
                method: 'POST',
                body: patientListConfig,
            }),
        }),
        allPatientList: builder.mutation({
            query: (config = { email: '', mobile: '' }) => ({
                url: '/patient/search',
                method: 'POST',
                body: config,
            }),
        }),
        allPatientDropdownList: builder.mutation({
            query: (config = { email: '', mobile: '' }) => ({
                url: '/patient/dropdownlist',
                method: 'POST',
                body: config,
            }),
        }),
        addPatient: builder.mutation({
            query: (addPatientConfig) => ({
                url: '/patient/add',
                method: 'POST',
                body: addPatientConfig,
            }),
        }),
        editUser: builder.mutation({
            query: (addPatientConfig) => ({
                url: '/user/edit',
                method: 'POST',
                body: addPatientConfig,
            }),
        }),
        patientCount: builder.mutation({
            query: () => ({
                url: '/user/count',
                method: 'POST',
                body: { type: 'PATIENT' },
            }),
        }),
        patientDraftDelete: builder.mutation({
            query: (userId) => ({
                url: '/patient/PatientDraftDelete',
                method: 'POST',
                body: { userId },
            }),
        }),
        patientDraftUpdate: builder.mutation({
            query: (draftData) => ({
                url: '/patient/PatientDraftUpdate',
                method: 'POST',
                body: draftData,
            }),
        }),
        patientDraftApprove: builder.mutation({
            query: (approveData) => ({
                url: '/patient/PatientDraftApprove',
                method: 'POST',
                body: approveData,
            }),
        }),
        patientExport: builder.mutation({
            query: (exportData) => ({
                url: '/patient/export',
                method: 'POST',
                body: exportData,
                responseHandler: (response) => response.blob(),
            }),
        }),
        patientExcelFile: builder.mutation({
            query: (formData) => ({
                url: '/patient/PatientExcelFile',
                method: 'POST',
                body: formData,
                formData: true,
            }),
        }),
        // Add the draft import endpoint
        patientDraftImport: builder.mutation({
            query: (formData) => ({
                url: '/patient/PatientExcelFile',
                method: 'POST',
                body: formData,
                formData: true,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    usePatientListMutation,
    usePatientCountMutation,
    useAddPatientMutation,
    useAllPatientListMutation,
    useAllPatientDropdownListMutation,
    useEditUserMutation,
    usePatientDraftListMutation,
    usePatientDraftDeleteMutation,
    usePatientDraftUpdateMutation,
    usePatientDraftApproveMutation,
    usePatientExportMutation,
    usePatientExcelFileMutation,
    usePatientDraftImportMutation, // Export the new mutation
} = injectedPatientApi;

export default patientApi;